import { createContext, useContext } from "react";

/** The way back out of the page around this content, or `null` when it is a sheet (the scrim and footer close those). */
export type SheetBack = { onBack: () => void; label: string };

/**
 * Lets a `SheetStep` opened as a full page draw a ‹ back button in its heading, as the design's pages do, without each
 * step knowing whether it is shown as a sheet or a page.
 */
export const SheetBackContext = createContext<SheetBack | null>(null);

export const useSheetBack = (): SheetBack | null => useContext(SheetBackContext);
